import { Facet, withSearch } from "@elastic/react-search-ui";
import React, { useContext } from "react";
import ResultSelectContext from "../../../providers/ResultSelectContext";

function FilterSelectList({ ...props }) {
  const { setSelectedResultIds } = useContext(ResultSelectContext);

  const moveOthersOptionAtTheEnd = (options) => {
    const otherOptionIndex = options.findIndex((option) =>
      ["その他", "Other", "Others"].includes(option.value ?? ""),
    );

    if (otherOptionIndex !== -1) {
      const otherOption = options.splice(otherOptionIndex, 1)[0];
      options.push(otherOption);
    }
  };

  return (
    <ul className="p-filter__list">
      <Facet
        {...props}
        view={(args) => {
          moveOthersOptionAtTheEnd(args.options);

          return args.options
            .filter((checkboxData) => checkboxData.value)
            .map((checkboxData, index) => {
              const selected = checkboxData.selected;
              return (
                <li
                  key={index}
                  className="sui-multi-checkbox-facet__checkbox"
                  checked={selected}
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedResultIds({});
                    if (checkboxData.value) {
                      selected
                        ? args.onRemove(checkboxData.value)
                        : args.onSelect(checkboxData.value);
                    }
                  }}
                >
                  <label>
                    <input type="checkbox" checked={selected} readOnly />
                    <span>{checkboxData.value}</span>
                  </label>
                </li>
              );
            });
        }}
      />
    </ul>
  );
}

export default withSearch(({ filters }) => ({ filters }))(FilterSelectList);
